const features = [
  {
    icon: 'ri-stack-line',
    title: '多平台覆盖',
    desc: '全面收录97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等热门在线视频平台，一站对比无需跳转多个网站。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时追踪更新',
    desc: '持续监测各平台动态变化，第一时间汇总重要更新信息，让你不错过任何影响观影体验的关键变化。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '客观信息导航',
    desc: '坚持中立立场，不偏袒任何平台，仅提供客观的平台信息对比和实用指南，把选择权完全交给你。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            核心特色
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            为什么选择榴莲视频
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            三大核心优势，打造最实用的在线视频平台导航
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="text-center p-6 bg-background-50 rounded-xl border border-background-200/60"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 font-heading mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}